import React, { useEffect, useRef, useState } from "react";
import ExpirySoonBottomSheet from "../ExpirySoonBottomSheet/ExpirySoonBottomSheet";
import * as actionCreator from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { checkPaymentStatusGetService } from "@src/PaymentService/services";

const PaymentProcessingBottomSheet = () => {
  const [num, setNum] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showPaymentProcessingBottomSheet
  );

  let intervalRef = useRef();

  useEffect(() => {
    intervalRef.current = setInterval(increaseNum, 2000);
    return () => stopCountdown();
  }, []);

  useEffect(() => {
    // console.log("num", num);

    if (num >= 120) {
      window?.handleRefreshCourseData();
      onPaymentProcessingModalClose();
      return;
    }

    checkPaymentStatus();
  }, [num]);

  const increaseNum = () => setNum((prev) => prev + 2);

  const checkPaymentStatus = async () => {
    let orderId = window.localStorage.getItem("orderId");

    try {
      let response = await checkPaymentStatusGetService(orderId);

      // alert(JSON.stringify(response));

      let responseState = response?.data?.data?.state;

      if (responseState == "captured") {
        // dispatch(actionCreator.)
        dispatch(actionCreator.showPaymentProcessingBottomSheetAction(false));
        dispatch(
          actionCreator.showCongratulationsBottomSheetAction({
            show: true,
            bottomCard: response?.data?.data?.bottomCard,
          })
        );

        stopCountdown();
      } else if (responseState == "failure") {
        dispatch(actionCreator.showPaymentProcessingBottomSheetAction(false));
        dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));

        stopCountdown();
      } else if (responseState == "pending") {
        // dispatch(actionCreator.showPaymentProcessingBottomSheetAction(true));
        // continue
        // console.log("polling");
      }
    } catch (err) {
      // console.log("error", err);
      // alert(JSON.stringify(err));
      dispatch(actionCreator.showPaymentFailedBottomSheetAction(true));
      dispatch(actionCreator.showPaymentProcessingBottomSheetAction(false));
    }
  };

  const stopCountdown = () => {
    clearInterval(intervalRef.current);
  };

  const onPaymentProcessingModalClose = () => {
    stopCountdown();

    dispatch(actionCreator.showPaymentProcessingBottomSheetAction(false));
  };

  return (
    <ExpirySoonBottomSheet
      mainText={t(
        "components.bottomSheets.components.paymentProcessingBottomSheet.paymentProcessing",
        "Payment Processing"
      )}
      detailText={t(
        "components.bottomSheets.components.paymentProcessingBottomSheet.paymentUnderProcessing",
        "Your payment is currently under processing. Please wait for sometime."
      )}
      showButton={false}
      subTextBelowBtn={false}
      state={state}
      onClose={() => {
        onPaymentProcessingModalClose();
      }}
    />
  );
};

export default PaymentProcessingBottomSheet;
